import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { kolData } from "../data/kol.js";
import { textLengthFiltered, shuffleData } from "../utils/common";
import { trackEvent } from "../utils/analytics";

const Kol = () => {
    const screenWidth = useRef(window.innerWidth).current;
    const shuffleNewData = shuffleData(kolData);

    // 埋設 GA 點擊 KOL 旅遊攻略按鈕傳送參數
    const sendGaEventKolTravel = (e) => {
        trackEvent("event", "Click", {
            "event_category": "Kol",
            "event_label": e.currentTarget.dataset.label,
            "value": 1
        });
    };

    // 埋設 GA 點擊 KOL 旅遊攻略按鈕傳送參數
    const sendGaEventKolStore = (e) => {
        const kolArr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
        const kolId = e.currentTarget.dataset.kolid;
        const newLabel = `kol${kolArr[kolId - 1]}_click`;
        trackEvent("event", "Click", {
            "event_category": "Kol",
            "event_label": newLabel,
            "value": 1
        });
    };

    return (
        <section id="kol" className="kol">
            <h2
                className="title"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                潮Way達人導航
            </h2>
            <h3
                className="description"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                快來蒐集達人私藏行程<br />
                跟著感覺走！挖掘更多台南寶藏！
            </h3>
            {
                screenWidth > 767 ?
                    (
                        <div
                            className="list container"
                            data-aos="fade-in"
                            data-aos-easing="linear"
                            data-aos-duration="1000"
                        >
                            {
                                shuffleNewData.slice(0, 6).map((item, i) => (
                                    <div className="item" key={item.id}>
                                        <div className="kol-img">
                                            <picture>
                                                <source media="(max-width: 1440px)" srcSet={item.imageSmall} />
                                                <img
                                                    loading="lazy"
                                                    src={item.image}
                                                    alt="kol-img"
                                                />
                                            </picture>
                                        </div>
                                        <h3 className="kol-name">
                                            {item.name}
                                        </h3>
                                        <div className="kol-article top">
                                            <div>
                                                <a
                                                    href={item.lazyArticle.link}
                                                    target="_blank"
                                                    onClick={sendGaEventKolTravel}
                                                    data-label={`kol${item.id}_click`}
                                                    rel="noreferrer"
                                                >
                                                    <h4>{textLengthFiltered(item.lazyArticle.title, 14)}</h4>
                                                </a>
                                            </div>
                                            <div>
                                                <a
                                                    href={item.recommendArticle.link}
                                                    target="_blank"
                                                    onClick={sendGaEventKolStore}
                                                    data-kolid={item.id}
                                                    rel="noreferrer"
                                                >
                                                    <h4>{textLengthFiltered(item.recommendArticle.title, 14)}</h4>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            {
                                shuffleNewData.slice(6, 11).map((item, i) => (
                                    <div className="item" key={item.id}>
                                        <div className="kol-img">
                                            <picture>
                                                <source media="(max-width: 1440px)" srcSet={item.imageSmall} />
                                                <img
                                                    loading="lazy"
                                                    src={item.image}
                                                    alt="kol-img"
                                                />
                                            </picture>
                                        </div>
                                        <h3 className="kol-name">
                                            {item.name}
                                        </h3>
                                        <div className="kol-article bottom">
                                            <div>
                                                <a
                                                    href={item.lazyArticle.link}
                                                    target="_blank"
                                                    onClick={sendGaEventKolTravel}
                                                    data-label={`kol${item.id}_click`}
                                                    rel="noreferrer"
                                                >
                                                    <h4>{textLengthFiltered(item.lazyArticle.title, 14)}</h4>
                                                </a>
                                            </div>
                                            <div>
                                                <a
                                                    href={item.recommendArticle.link}
                                                    target="_blank"
                                                    onClick={sendGaEventKolStore}
                                                    data-kolid={item.id}
                                                    rel="noreferrer"
                                                >
                                                    <h4>{textLengthFiltered(item.recommendArticle.title, 14)}</h4>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ) :
                    (
                        <div
                            className="list container kol-slider"
                            data-aos="fade-in"
                            data-aos-easing="linear"
                            data-aos-duration="1000"
                        >
                            <Swiper
                                modules={[Autoplay]}
                                slidesPerView={2.16}
                                spaceBetween={24}
                                centeredSlides={true}
                                autoplay={{ delay: 5000 }}
                                loop={true}
                            >
                                {
                                    shuffleNewData.map((item, i) => (
                                        <SwiperSlide className="item" key={item.id}>
                                            <div className="kol-img">
                                                <picture>
                                                    <source media="(max-width: 1440px)" srcSet={item.imageSmall} />
                                                    <img
                                                        loading="lazy"
                                                        src={item.image}
                                                        alt="kol-img"
                                                    />
                                                </picture>
                                            </div>
                                            <h3 className="kol-name">
                                                {item.name}
                                            </h3>
                                            <div className="kol-article">
                                                <div>
                                                    <a
                                                        href={item.lazyArticle.link}
                                                        target="_blank"
                                                        onClick={sendGaEventKolTravel}
                                                        data-label={`kol${item.id}_click`}
                                                        rel="noreferrer"
                                                    >
                                                        <h4>{textLengthFiltered(item.lazyArticle.title, 14)}</h4>
                                                    </a>
                                                </div>
                                                <div>
                                                    <a
                                                        href={item.recommendArticle.link}
                                                        target="_blank"
                                                        onClick={sendGaEventKolStore}
                                                        data-kolid={item.id}
                                                        rel="noreferrer"
                                                    >
                                                        <h4>{textLengthFiltered(item.recommendArticle.title, 14)}</h4>
                                                    </a>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                    )
            }
        </section>
    );
};

export default Kol;
